"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.symbol = symbol;
function symbol() {
    // eslint-disable-next-line max-len,quotes
    return '<symbol viewbox="0 0 24 24" fill=none id=icon-spinner-24><path d="M22.5 12A10.5 10.5 0 1 1 9.514 1.798" stroke="var(--color-spinner-icon-background, #3665F3)" stroke-width=3 stroke-linecap=round stroke-linejoin=round></path><path d="M14.606 1.829a10.5 10.5 0 0 1 4.056 2.055 10.499 10.499 0 0 1 2.806 3.577" stroke-width=3 stroke-linecap=round stroke-linejoin=round stroke="var(--color-spinner-icon-foreground, #E5E5E5)"></path></symbol>';
}
